import React__default from 'react';
var LinksGroup = function LinksGroup(_ref) {
  var _ref$category = _ref.category,
    category = _ref$category === void 0 ? "" : _ref$category,
    _ref$links = _ref.links,
    links = _ref$links === void 0 ? [] : _ref$links,
    handleClick = _ref.handleClick;
  function onClick(e) {
    var linkElement = e == null ? void 0 : e.target;
    var payload = {
      elementType: "link",
      location: "footer",
      position: category,
      text: linkElement.text
    };
    if (handleClick) {
      handleClick(payload);
    }
  }
  return /* @__PURE__ */React__default.createElement("div", {
    className: "footer-cp__links-group"
  }, /* @__PURE__ */React__default.createElement("h2", {
    className: "footer-cp__title"
  }, category), /* @__PURE__ */React__default.createElement("ul", {
    className: "footer-cp__links-list"
  }, links.map(function (_ref2, index) {
    var title = _ref2.title,
      link = _ref2.link,
      target = _ref2.target;
    return /* @__PURE__ */React__default.createElement("li", {
      key: "links-list-".concat(category, "-").concat(index)
    }, /* @__PURE__ */React__default.createElement("h3", null, !!link && /* @__PURE__ */React__default.createElement("a", {
      href: link,
      target: target,
      rel: "noopener",
      className: "footer-cp__link",
      onClick: onClick
    }, title), !link && /* @__PURE__ */React__default.createElement("p", {
      className: "footer-cp__text"
    }, title)));
  })));
};
export { LinksGroup as default };